import React from "react";
import "./Button.scss";

export default function Button({
  submitPermission,
  onClick,
  tabIndex,
  label,
  size = "medium",
  type = "",
}) {
  return (
    <div className="Button">
      <div
        tabIndex={tabIndex}
        className={`${
          submitPermission
            ? "next-button-green " + size + " " + type
            : "next-button " + size + " " + type
        }`}
        onClick={onClick}
      >
        {label}
      </div>
    </div>
  );
}
